module.exports = __webpack_public_path__ + "img/Asset1.85428053.png";